import { z } from 'zod/v4'
import { paginationLinksSchema, paginationMetaSchema } from './pagination'
import { mediaSchema } from '@/lib/schema/v2/media'
import { zDayJs } from '@/lib/schema/v2/dayjs'
import { ampApiErrorSchema } from '@/lib/schema/v2/amp-api-response'

export const tenantSchema = z.object({
    created_at: zDayJs.nullish(),
    is_active: z.boolean().nullish(),
    name: z.string().nullish(),
    updated_at: zDayJs.nullish(),
    uuid: z.uuid().nullish(),
    abn: z.string().nullish(),
    admin_contact_phone: z.string().nullish(),
    business_thought: z.string().nullish(),
    contact_email: z.email().nullish(),
    contact_phone: z.string().nullish(),
    default_email: z.email().nullish(),
    eft_account_name: z.string().nullish(),
    eft_account_number: z.string().nullish(),
    eft_bsb: z.string().nullish(),
    fax: z.string().nullish(),
    legal_name: z.string().nullish(),
    legal_type: z.string().nullish(),
    logo: mediaSchema.nullish(),
    logo_uuid: z.uuid().nullish(),
    customer_portal_url: z.url().nullish(),
    postal_address: z.string().nullish(),
    privacy_url: z.url().nullish(),
    sfoa_url: z.url().nullish(),
    ticket_email_signature_image_url: z.string().nullish(),
    timezone_uuid: z.uuid().nullish(),
    title: z.string().nullish(),
    website: z.url().nullish(),
})

export const tenantsSchema = z.array(tenantSchema)

export const paginatedTenantsResponseSchema = z.object({
    data: tenantsSchema.nullish(),
    links: paginationLinksSchema.nullish(),
    meta: paginationMetaSchema.nullish(),
    success: z.boolean(),
    error: ampApiErrorSchema.nullish(),
})

export const retrieveTenantResponseSchema = z.object({
    data: tenantSchema.nullish(),
    success: z.boolean(),
    error: ampApiErrorSchema.nullish(),
})

export const tenantCreateSchema = z.object({
    abn: z.string(),
    admin_contact_phone: z.string(),
    business_thought: z.string(),
    contact_email: z.email(),
    contact_phone: z.string(),
    default_email: z.email(),
    eft_account_name: z.string(),
    eft_account_number: z.string(),
    eft_bsb: z.string(),
    fax: z.string(),
    legal_name: z.string(),
    legal_type: z.string(),
    customer_portal_url: z.url(),
    postal_address: z.string(),
    privacy_url: z.url(),
    sfoa_url: z.url(),
    ticket_email_signature_image_url: z.url(),
    timezone_uuid: z.uuid(),
    title: z.string(),
    website: z.url(),
})

export type PaginatedTenantsResponse = z.infer<typeof paginatedTenantsResponseSchema>
export type Tenant = z.infer<typeof tenantSchema>
export type Tenants = z.infer<typeof tenantsSchema>
export type TenantForm = z.infer<typeof tenantCreateSchema>
export type RetrieveTenantResponse = z.infer<typeof retrieveTenantResponseSchema>
